import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import md5 from 'md5';
import FileSaver from 'file-saver';
import _ from 'lodash';
import { Row, Col, Button } from 'reactstrap';
import Lightbox from 'react-image-lightbox';
import Select from 'react-select';
import Img from 'react-image';
import LazyLoad from 'react-lazyload';
import axios from 'axios';

import Loader from '../../components/Loader';

import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

const PhotoGallery = ({ data, i18n, ...props }) => {
  const { translations = {}, locale } = i18n || {};
  const t = translations[locale] || {};

  const [isOpen, setIsOpen] = useState(false);
  const [galleryList, setGalleryList] = useState(null);
  const [galleryIndex, setGalleryIndex] = useState(0);
  const [gallery, setGallery] = useState(null);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [sectionGallery, setSectionGallery] = useState(null);
  const [options, setOptions] = useState([]);
  const [select, setSelect] = useState(0);
  const [defaultDropdown, setDefaultDropdown] = useState(null);
  const [defaultViewPhoto, setDefaultViewPhoto] = useState(null);

  const { id } = useParams();

  const modalLoaded = useRef(null);

  const sectionGroup = (section) => {
    return _(section.images)
      .groupBy((v) => v.subTitle)
      .map((v, k) => {
        return {
          subTitle: k === 'undefined' ? '' : k,
          images: v,
        };
      })
      .value();
  };

  useEffect(() => {
    defaultViewPhoto && viewClick(defaultViewPhoto.index, defaultViewPhoto.subTitle);
  }, [modalLoaded, defaultViewPhoto]);

  useEffect(() => {
    console.log(`data Change`);
    if (data) {
      checkDefaultDropdown(JSON.parse(data));
      setGalleryList(JSON.parse(data));
    }
  }, [data]);

  useEffect(() => {
    console.log(`galleryList Change: ${galleryList}`);
    if (galleryList) {
      console.log(defaultDropdown);
      const i = defaultDropdown || 0;
      setGalleryIndex(i);
      const defaultOption = {
        value: i,
        label: galleryList[i].title,
      };
      setSelect(defaultOption);
      setPhotoIndex(0);
    }
  }, [galleryList]);

  useEffect(() => {
    console.log(`[galleryIndex], galleryList Change: ${galleryIndex}`);
    console.log(`galleryIndex, [galleryList] Change: ${galleryList}`);
    if (galleryList) {
      const gallerySections = sectionGroup(galleryList[galleryIndex]);
      setGallery(gallerySections);
      setPhotoIndex(0);
    }
  }, [galleryIndex, galleryList]);

  useEffect(() => {
    console.log(`gallery Change: ${gallery}`);
    if (galleryList) {
      const optionsMap = galleryList.map((v, k) => {
        return {
          value: k,
          label: v.title,
        };
      });

      setOptions(optionsMap);
    }
  }, [gallery]);

  const handleDownload = (event, downloadLink, photoTitle) => {
    axios({
      url: downloadLink,
      method: 'GET',
      responseType: 'blob', // important
    })
      .then((response) => {
        // assume PhotoGallery only support JPG
        const fileName = `${photoTitle || `${Math.random()}`.substring(2)}.jpg`;
        FileSaver.saveAs(new Blob([response.data]), fileName);
      })
      .catch(() => {
        window.open(downloadLink);
      });
  };

  const checkDefaultDropdown = (jData) => {
    let defaultDropdownIndex;
    let defaultSubTitle;
    let defaultPhoto;
    let matchPhoto = false;

    const data = jData.map((v) => {
      return {
        title: v.title,
        gallery: sectionGroup(v),
      };
    });

    data.forEach((v, k) => {
      v.gallery.forEach((vv) => {
        vv.images.forEach((vvv, kkk) => {
          const hashPhoto = md5(vvv.photo);
          if (hashPhoto === id) {
            matchPhoto = true;
            defaultDropdownIndex = k;
            defaultSubTitle = vv.subTitle;
            defaultPhoto = kkk;
          }
        });
      });
    });

    if (matchPhoto) {
      setDefaultDropdown(defaultDropdownIndex);
      setTimeout(() => {
        setDefaultViewPhoto({
          index: defaultPhoto,
          subTitle: defaultSubTitle,
        });
      }, 200);
    }
  };

  const viewClick = (index, subTitle) => {
    console.log(index, subTitle);
    console.log(gallery);
    gallery && setSectionGallery(gallery.find((v) => v.subTitle === subTitle));
    setPhotoIndex(index);
    setIsOpen(true);
  };

  const imageItemButtons = (index, photoUrl, photoTitle, subTitle) => (
    <div className="gallery__item__buttons">
      <Button color="primary" size="sm" onClick={() => viewClick(index, subTitle)}>
        {t.photo.view}
      </Button>
      <button
        type="button"
        className="btn btn-secondary btn-sm"
        title={photoUrl}
        onClick={(e) => handleDownload(e, photoUrl, photoTitle)}
      >
        {t.photo.download}
      </button>
    </div>
  );

  const imageItem = (item, index, subTitle) => (
    <Col md="4" lg="3" className="mb-4" key={index}>
      <div className="gallery__item__wrapper">
        <LazyLoad>
          <Img
            className="img-fluid gallery__item__img"
            src={item.thumbnail}
            alt={item.alt}
            decode={false}
            loader={<Loader />}
            unloader={<span>X</span>}
          />
        </LazyLoad>
        {(item.speaker || item.company) && item.type === 's' && (
          <div className="gallery__item__detail">
            {item.speaker && <div className="gallery__item__detail__title">{item.speaker}</div>}
            {item.company && (
              <div className="gallery__item__detail__desc gallery__item__detail-height mb-3">
                {item.company}
              </div>
            )}
          </div>
        )}

        {imageItemButtons(index, item.photo, item.alt, subTitle)}
      </div>
    </Col>
  );

  const lightBoxEle = (images, index) => (
    <Lightbox
      ref={modalLoaded}
      mainSrc={images[index]}
      nextSrc={images[(index + 1) % images.length]}
      prevSrc={images[(index + images.length - 1) % images.length]}
      onCloseRequest={() => setIsOpen(false)}
      onMovePrevRequest={() => setPhotoIndex((index + images.length - 1) % images.length)}
      onMoveNextRequest={() => setPhotoIndex((index + 1) % images.length)}
    />
  );

  const sectionEle = (gallerySection) => {
    return <>{gallerySection.images.map((v, k) => imageItem(v, k, gallerySection.subTitle))}</>;
  };

  return (
    <>
      <Select
        className="mb-4"
        value={select}
        options={options}
        onChange={(option) => {
          setGalleryIndex(option.value);
          setSelect(option);
        }}
      />
      <div>
        {gallery &&
          gallery.map((v, k) => {
            return (
              <div className="mb-2" key={k}>
                {v.subTitle && <h5>{v.subTitle}</h5>}
                <Row>{v && sectionEle(v)}</Row>
              </div>
            );
          })}
        {isOpen &&
          sectionGallery &&
          lightBoxEle(
            sectionGallery.images.map((v) => v.photo),
            photoIndex,
          )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(PhotoGallery);

export { PhotoGallery as PhotoGalleryComponent }; // <- For component Unit Test
export default connectStore;
